module.exports = __webpack_public_path__ + "static/1307458765.561ea8d7.jpg";